import script from "./MyDiscountView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyDiscountView.vue?vue&type=script&setup=true&lang=ts"

import "./MyDiscountView.vue?vue&type=style&index=0&id=72a79f57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a79f57"]])

export default __exports__